import type { FrontendComponentRow } from '../../repositoryblueprint/framework';

type Props = { items?: FrontendComponentRow[] };

export function FrontendComponentPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.tier}-${item.path}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-xs font-medium text-brand-600">{item.tier}</p>
            <p className="font-mono text-xs text-slate-500">{item.path}</p>
          </div>
          <p className="mt-1 text-sm">{item.examples}</p>
          <p className="text-xs text-slate-500">Used by: {item.consumers}</p>
        </div>
      ))}
    </div>
  );
}
